<template>
  <article
    class="note"
    :class="{ deleted: isDeleted, left: !isOwnerOfNote, right: isOwnerOfNote }"
  >
    <section class="title">
      <UserIcon
        :first-name="note.firstName"
        :last-name="note.lastName"
        class="mr-10"
      />
      <h2 class="title-name">
        <span v-if="showIsArchived" style="margin-right: 4px; color: red"
          >[Arkiv]</span
        >

        <span
          >{{ note.firstName }} {{ note.lastName }}<br /><span
            class="title-text"
            ><strong style="font-weight: 600">{{ getSubName(note) }}</strong>
            ({{ getNoteDate(note) }})</span
          ></span
        >
      </h2>
      <div class="note-controls">
        <span v-if="note.editedAt && !isDeleted" class="note-edited-msg"
          >(Redigerad)</span
        >
        <template v-if="showControls && isOwnerOfNote">
          <div v-if="!isDeleted" class="btns-container">
            <button
              class="edit-note-btn note-btn"
              type="button"
              @click="$emit('setActiveEditNote', note)"
            >
              <Pen :color="isOwnerOfNote ? '#fff' : ''" />
            </button>
            <button
              class="delete-note-btn note-btn"
              type="button"
              @click="$emit('showDeleteNote', note.id)"
            >
              <Trash :color="isOwnerOfNote ? '#fff' : ''" />
            </button>
          </div>
        </template>
      </div>
    </section>

    <p class="note-text">
      <span v-if="isDeleted" class="note-deleted-msg">
        <i>Borttagen</i>
      </span>
      <span v-else>
        {{ note.text }}
      </span>
    </p>
  </article>
</template>

<script>
import { mapState } from 'vuex';

import UserIcon from '@/components/UserIcon.vue';
import Trash from '@/components/Icons/Trash.vue';
import Pen from '@/components/Icons/Pen.vue';

export default {
  name: 'Note',
  components: {
    UserIcon,
    Trash,
    Pen
  },

  props: {
    showIsArchived: {
      type: Boolean,
      required: false
    },
    showControls: {
      type: Boolean,
      required: false
    },
    note: {
      type: Object,
      required: true
    }
  },
  emits: ['setActiveEditNote', 'showDeleteNote'],

  computed: {
    ...mapState({
      account: state => state.app.account
    }),
    isDeleted() {
      return this.note.deletedAt;
    },
    isOwnerOfNote() {
      if (!this.account) {
        return false;
      }
      const userIdMatch = this.note.userId === this.account.userId;
      if (this.note.managerId) {
        return this.note.managerId === this.account.managerId && userIdMatch;
      }
      return this.note.landlordId === this.account.landlordId && userIdMatch;
    }
  },
  methods: {
    getSubName(note) {
      return note.managerName || note.landlordName || '';
    },
    getNoteDate(note) {
      const dateStr = new Date(note.updatedAt).toLocaleDateString('sv-SE');
      const timeStr = new Date(note.updatedAt).toLocaleTimeString('sv-SE');
      const hhmm = timeStr.substring(0, 5);
      return `${dateStr} ${hhmm}`;
    }
  }
};
</script>

<style scoped>
.mr-10 {
  margin-right: 10px;
}
.note {
  position: relative;
  background-color: #e9e9eb;
  padding: 15px 15px;
  border-radius: 10px;
  line-height: 1.4;
  width: 75%;
}

.note.left {
  align-self: flex-start;
  background-color: #f0f0f0;
}

.note.left::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 20px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: #f0f0f0;
  border-bottom: 0;
  margin-left: -5px;
}

.note.right {
  align-self: flex-end;
  background-color: var(--color-blue);
}

.note.right::after {
  content: '';
  position: absolute;
  bottom: -10px;
  right: 20px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: var(--color-blue);
  border-bottom: 0;
  margin-right: -5px;
}

.note.right .note-text,
.note.right .title-name,
.note.right .note-edited-msg {
  color: #fff;
}

.note.right .title-text {
  color: #f9f9f9;
}

.title {
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1.2rem;
}
.title-name {
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--color-dark-blue);
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-text {
  font-size: 1.1rem;
  font-weight: 400;
  color: #757575;
}

.note-controls {
  display: flex;
  align-items: center;
  margin-right: 0;
  margin-left: auto;
  align-self: flex-start;
}

.note-edited-msg {
  color: #000;
  margin-left: 3px;
  font-weight: 600;
}

.note-btn {
  height: 1.2rem;
  width: 1.2rem;
  padding: 0;
  border: none;
  box-shadow: none;
  background: none;
  cursor: pointer;
}
.note-btn > * {
  height: 100%;
  width: 100%;
}

.btns-container {
  display: inline-flex;
  justify-self: center;
  align-items: center;
  gap: 5px;
  margin-left: 5px;
  height: 100%;
}

.note-deleted-msg {
  font-size: 1rem;
}

.note-text {
  margin-top: 0.8rem;
  color: var(--color-dark-blue);
  font-weight: 400;
  font-size: 1.2rem;
  font-family: var(--font-inter);
  line-height: 1.5;
  white-space: pre-wrap;
}

.deleted {
  opacity: 0.5;
}
</style>
